import React from 'react';
import { Minus, Plus } from 'lucide-react';

const QuantityStepper = ({
  value = 1,
  onChange,
  min = 1,
  max = 999,
  step = 1,
  disabled = false,
  size = 'md',
  className = '',
}) => {
  const handleDelta = (delta) => {
    if (!onChange) return;
    const next = Math.min(max, Math.max(min, Number(value) + delta));
    if (next !== Number(value)) onChange(next);
  };

  const handleInput = (e) => {
    const next = parseInt(e.target.value, 10);
    if (Number.isNaN(next)) return;
    onChange?.(Math.min(max, Math.max(min, next)));
  };

  const sizeClasses = size === 'sm' ? 'h-8 text-sm' : 'h-10 text-base';
  const btnSize = size === 'sm' ? 'w-8' : 'w-10';
  const iconSize = size === 'sm' ? 14 : 16;

  return (
    <div
      className={`inline-flex items-stretch rounded-lg border border-app-border overflow-hidden ${sizeClasses} ${
        disabled ? 'opacity-50' : ''
      } ${className}`}
    >
      <button
        type="button"
        onClick={() => handleDelta(-step)}
        disabled={disabled || Number(value) <= min}
        className={`${btnSize} flex items-center justify-center text-app-text hover:bg-app-surface-hover disabled:text-app-text-secondary disabled:cursor-not-allowed transition-colors`}
        aria-label="Diminuir"
      >
        <Minus size={iconSize} />
      </button>
      <input
        type="number"
        value={value}
        onChange={handleInput}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        className="w-12 text-center text-app-text border-x border-app-border focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
      <button
        type="button"
        onClick={() => handleDelta(step)}
        disabled={disabled || Number(value) >= max}
        className={`${btnSize} flex items-center justify-center text-app-text hover:bg-app-surface-hover disabled:text-app-text-secondary disabled:cursor-not-allowed transition-colors`}
        aria-label="Aumentar"
      >
        <Plus size={iconSize} />
      </button>
    </div>
  );
};

export default QuantityStepper;
